export enum ReferralType {
  MedicalReferral = 'Medical Referral',
  AppropriatenessReview = 'Appropriateness Review',
}
